import { c as _c } from "react/compiler-runtime";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper/modules';
import React from 'react';
import { ImageSet } from '@/src/lib/product/types.ts';
import ProductSliderImageItem from '@/src/app/[country]/[lang]/shop/[...segments]/(product-details)/components/ProductImageGallery/ProductSliderImageItem.tsx';
export type ProductThumbsSliderProps = {
  imageSet: ImageSet;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setThumbsSwiper: any;
  productName: string;
};
export default function ProductThumbsSlider(t0) {
  const $ = _c(9);
  const {
    imageSet,
    setThumbsSwiper,
    productName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [Navigation, Thumbs];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== imageSet.images || $[2] !== productName) {
    let t3;
    if ($[4] !== productName) {
      t3 = image => <SwiperSlide key={image.externalUrlSmall}><ProductSliderImageItem url={image.externalUrlSmall} alt={`Thumbnail for ${productName}`} width={100} height={100} useZoom={false} quality={75} /></SwiperSlide>;
      $[4] = productName;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = imageSet.images.map(t3);
    $[1] = imageSet.images;
    $[2] = productName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== setThumbsSwiper || $[7] !== t2) {
    t3 = <Swiper onSwiper={setThumbsSwiper} slidesPerView="auto" observer={true} observeParents={true} freeMode={true} watchSlidesProgress={true} modules={t1} className="slider-thumbs">{t2}</Swiper>;
    $[6] = setThumbsSwiper;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}